import { render, staticRenderFns } from "./OnTrialPopup.vue?vue&type=template&id=674953dc&scoped=true"
import script from "./OnTrialPopup.vue?vue&type=script&lang=js"
export * from "./OnTrialPopup.vue?vue&type=script&lang=js"
import style0 from "./OnTrialPopup.vue?vue&type=style&index=0&id=674953dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674953dc",
  null
  
)

export default component.exports